module.exports = __webpack_public_path__ + "media/PAG80-03.7ecc530d.mp3";